import { z } from 'zod';

// Reusable paging contract. Coerces so it can bind directly to a query string.
export const PageQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
export type PageQuery = z.infer<typeof PageQuerySchema>;

// Reusable free-text search contract.
export const SearchQuerySchema = z.object({
  search: z.string().trim().min(1).optional(),
});
export type SearchQuery = z.infer<typeof SearchQuerySchema>;
